// @flow
import React from 'react';
import Slider from 'react-slick';

import { WhitePanel } from '../UI';
import data from './data';

import './featured-places.css';

type GalleryArrowProps = {
  onClick: () => void,
  direction: string,
};

const GalleryArrow = ({ onClick, direction }: GalleryArrowProps) => (
  <div className={`control ${direction}`}>
    <a role="button" onClick={onClick}>
      <div className="circle">
        <i className={`icon icon-hg-chev-${direction}`} />
      </div>
    </a>
  </div>
);

const Settings = {
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: false,
  swipe: true,
  dots: false,
  centerPadding: '10px',
  nextArrow: <GalleryArrow direction="right" />,
  prevArrow: <GalleryArrow direction="left" />,
  responsive: [
    {
      breakpoint: 1200,
      settings: { infinite: false, slidesToShow: 3, slidesToScroll: 1 },
    },
    {
      breakpoint: 1024,
      settings: { infinite: false, slidesToShow: 3, slidesToScroll: 1 },
    },
    { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
    { breakpoint: 750, settings: { slidesToShow: 2, slidesToScroll: 1 } },
    { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
  ],
};

export default function FeaturePlacesSlider({ dataKey }) {
  const { title, subTitle, places } = data[dataKey];
  return (
    <WhitePanel>
      <h2>{title} {subTitle && `(${subTitle})`}</h2>
      <Slider {...Settings} className="featured-slider featured-place-slider">
        {
          places.map(({ url, name, lodges, imageUrl }) => (
            <div key={name} className="item">
              <a href={url}>
                <div className="item-holder">
                  <img src={imageUrl} alt={name} />
                  <div className="text-holder">
                    <div>
                      <span>{name}</span>
                      <span className="lodges">+ {lodges} Lodges</span>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          ))
        }
      </Slider>
    </WhitePanel>
  );
}



// WEBPACK FOOTER //
// ./src/components/FeaturedPlacesSlider/FeaturedPlacesSlider.jsx